// tutorial: traduzioni delle stringhe della funzione di traduzione $t
// traduzione dei messaggi d'errore di vee-validate
const sk = {
    'countryCode': 'sk_sk',
    'Accetto il regolamento fidelity e la privacy policy': 'Súhlasím s vernostným programom a zásadamy ochrany osobných údajov',
    'Account creation': 'Vytvorenie účtu',
    'Add address': 'Doplňte adresu',
    'Address': 'Adresa',
    'Address label': 'Názov adresy',
    'Address label placeholder': 'napr. domov, práca atď.',
    'Amount': 'Suma',
    'Apply': 'Použiť',
    'Apply Discount': 'Uplatniť zľavu',
    'Are you sure you want to delete this item from cart': 'Naozaj chcete odstrániť túto položku z nákupného košíka?',
    'Are you sure you want to move this item to wishlist?': 'Naozaj chcete presunúť túto položku do zoznamu želaní?',
    'articles': 'Tovar',
    'articles inside': 'tovar v košíku',
    'Back': 'Späť',
    'Back to cart': 'Späť do košíka',
    'Back to shopping': 'Pokračovať v nákupe',
    'Back to store': 'Späť do obchodu',
    'Billing address': 'Fakturačná adresa',
    'Billing address is the same as the shipping address': 'Fakturačné údaje sa zhodujú s doručovacími údajmi',
    'Buy': 'Kúpiť',
    'Buy Now': 'Kúpiť teraz',
    'Buy now, pay later': 'Kúpte teraz, zaplaťte neskôr',
    'Cancel': 'Zmazať',
    'Cannot apply Gift Card': 'Darčekovú kartu nie je možné uplatniť',
    'Cannot apply glam card points': 'Nebolo možné uplatniť body Vašej karty WE Card',
    'Card issuer authentication failed': 'Overenie totožnosti vydavateľa karty zlyhalo',
    'Cart': 'Košík',
    'Cart content': 'Obsah košíka',
    'Change': 'Zmeniť',
    'Change address': 'Zmeniť adresu',
    'Change e-mail': 'Zmeniť e-mail',
    'Change pickup point': 'Zmeňte miesto vyzdvihnutia',
    'Check zip code': 'Skontrolujte PSČ',
    'Choose a shipping method in order to proceed': 'Pre pokračovanie vyberte spôsob dopravy',
    'Choose a store for the pick-up in order to proceed': 'Ak chcete pokračovať, vyberte si obchod na vyzdvihnutie',
    'Choose a zipcode in order to proceed': 'Ak chcete pokračovať, zvoľte si PSČ',
    'City': 'Mesto',
    'Close': 'Zatvoriť',
    'Closed': 'Zatvorené',
    'Color': 'Farba',
    'Complete your order': 'Ukončiť objednávku',
    'Condizioni di vendita': 'Podmienky predaja',
    'Confirm': 'Potvrdiť',
    'Continue': 'Pokračujte',
    'Continue as guest': 'Pokračovať bez prihlásenia',
    'Country': 'Krajina',
    'Coupon': 'Kupón',
    'Coupon Code': 'Zľavový kód',
    'Credit Card': 'Platobná karta',
    'Credit Card Number': 'Číslo karty',
    'data': 'dati',
    'Date of birth': 'Dátum narodenia',
    'Date of Birth': 'Dátum narodenia',
    'dd/mm/yyyy': 'dd/mm/rrrr',
    'Delete': 'Zmazať',
    'Delivery:': 'Doručenie:',
    'Description': 'Opis',
    'Do you have a discount code?': 'Máte zľavový kód?',
    'Enter your Gift Card here': 'Sem vsuňte vašu giftcard',
    'do-login': 'Prihláste sa',
    'done': 'hotový',
    'E-mail address': 'e-mailová adresa',
    'Edit': 'Upraviť',
    'Edit address': 'Upraviť adresu',
    'Edit Cart': 'Upraviť nákupný košík',
    'Email': 'e-mail',
    'Email and telephone number': 'e-mail a číslo telefónu',
    'email-remainder': 'Odoslali sme Vám e-mail na obnovenie hesla.. Kliknite na odkaz v pošte.',
    'Empty credit card fields': 'Prosíme, vyplňte údaje platobnej karty',
    'Enter shipping address': 'Zadajte dodaciu adresu',
    'Enter the points to be used here': 'Enter the points to be used here',
    'Error during payment authorization': 'Chyba počas autorizácie platby',
    'Error during registration': 'Chyba počas registrácie',
    'Error occurred while placing orde': 'Pri zadávaní objednávky sa vyskytla chyba',
    'Expire Date': 'Platnosť do',
    'Female': 'Žena',
    'Firstname': 'Krstné meno',
    'Forgot your password?': 'Zabudli ste heslo?',
    'Free': 'Zadarmo',
    'Friday': 'Piatok',
    'From': 'Od',
    'Gender': 'Pohlavie',
    'Gift Card': 'Gift Card',
    'Gift card and discount codes': 'Darčeková karta a zľavové kódy',
    'giftcardmsg': 'Giftcard {code}',
    'Glam card discount': 'Zľava bonus WE Card',
    'glamcard-bonusapplied': 'Uplatnené {bonus} body Vašej karty WE Card',
    'Go to checkout': 'Do pokladne',
    'Go to payment': 'Platba',
    'Go to shipping': 'Prejdite na prepravu',
    'Go to summary': 'Prejsť na zhrnutie',
    'Home delivery cost': 'Náklady na doručenie domov',
    'How many points do you want to use?': 'Akú výšku bonusu si želáte uplatniť?',
    'How much bonus do you want to use?': 'Koľko bodov chcete použiť?',
    'I don\'t want to receive the invoice': 'Nechcem dostať faktúru',
    'I want to receive the invoice': 'Vystaviť faktúru',
    'Identical to shipping address': 'Zhodná s doručovacou adresou',
    'Insert here coupon code': 'Tu vložte zľavový kód',
    'Insert here the shipping data': 'Tu zadajte svoje dodacie údaje',
    'Insert here your email to proceed, we will send you just the order updates': 'Pokračujte zadaním svojej e-mailovej adresy, aby sme mohli zaslať informácie o tejto objednávke',
    'Insert your billing address': 'Zadajte svoju fakturačnú adresu',
    'invoice': 'platba',
    'Invoice address': 'Fakturačná adresa',
    'Last name': 'Priezvisko',
    'Lastname': 'Priezvisko',
    'Leave': 'Zatvoriť',
    'Loading': 'Načítanie',
    'Loading payment form, please wait': 'Načítava sa platobný formulár, čakajte prosím',
    'Login': 'Prihlásenie',
    'Male': 'Muž',
    'Message': 'Správa',
    'Mobile phone': 'Telefónne číslo',
    'Monday': 'Pondelok',
    'Move item': 'Presunúť položku',
    'Move product': 'Presuňte produkt',
    'Name': 'Meno',
    'New address': 'Nová adresa',
    'New client': 'Nový zákazník',
    'No items in cart': 'Nákupný košík je prázdny',
    'No near stores': 'Žiadne obchody v blízkosti',
    'No shipping methods available': 'Nie je k dispozícii žiadny spôsob doručenia',
    'Not registered yet?': 'Nie ste zaregistrovaný?',
    'Ok': 'Ok',
    'Or': 'Alebo',
    'Order detail': 'Detail objednávky',
    'Order details': 'Detaily objednávky',
    'Order placed': 'Objednávka bola vystavená. Budete presmerovaný na stránku s rekapituláciou objednávky',
    'Order will be shipped to': 'Objednávka bude doručená',
    'Password': 'Heslo',
    'Password confirm': 'Potvrdiť heslo',
    'Pay': 'Zaplatiť',
    'payment': 'Platba',
    'Payment': 'Platba',
    'Payment error.': 'Chyba pri platbe',
    'Payment method': 'Spôsob platby',
    'Payment method not supported': 'Spôsob platby nie je podporovaný',
    'Personal data': 'Osobné údaje',
    'Place of birth': 'Miesto narodenia',
    'Place of Birth': 'Miesto narodenia',
    'Please select shipping from Amazon widget': 'Vyberte dopravu z miniaplikácie Amazon',
    'Please try again with another form of payment': 'Skúste to znova s iným spôsobom platby',
    'Please wait': 'Počkajte, prosím',
    'Please wait, payment is processing': 'Čakajte prosím, platba sa spracováva',
    'Postcode': 'PSČ',
    'Prefix': 'Predpona',
    'Proceed': 'Ďalej',
    'Proceed delete': 'Pokračujte',
    'Proceed to payment': 'Prejdite k platbe',
    'Proceed with the purchase': 'Pokračovať v nákupe',
    'product': 'výrobok',
    'Product': 'Výrobok',
    'products': 'výroboky',
    'Products total': 'Výrobky spolu',
    'Quantity': 'Množstvo',
    'Register': 'Registrovať sa',
    'Registered User': 'registrovaný používateľ',
    'Registration agreement': 'Podmienky registrácie',
    'Registration successful': 'Registrácia úspešná',
    'registrationagreement': 'Súhlasím s <a href="{linkfid}" target="_blank">podmienkami vernostného programu</a> a <a href="{linkpriv}" target="_blank">zásadami ochrany osobných údajov</a>',
    'Remove': 'Odstrániť',
    'Remove Discount': 'Odstrániť zľavu',
    'Remove the item': 'Odstrániť položku',
    'Required fields': 'Povinné políčka',
    'Retry': 'Skúsiť znova',
    'review': 'rekapitulácia',
    'Safe purchase': 'Bezpečný nákup',
    'Same as billing': 'Rovnaká ako fakturačná',
    'Saturday': 'Saturday',
    'Save': 'Uložiť',
    'Save address': 'Uložiť adresu',
    'Save in address book': 'Uložiť do adresára',
    'Save new address to proceed': 'Pokračujte uložením novej adresy',
    'Sconto (Fidelity card)': 'Zľava (vernostná karta)',
    'Select': 'Zvoľte',
    'Select a city': 'Zvoľte mesto',
    'Select a payment method': 'Zvoľte spôsob platby',
    'Select a region': 'Zvoľte kraj',
    'Select an address': 'Vyberte adresu',
    'Select here your shipping address': 'Tu vložte svoju dodaciu adresu',
    'Select payment method': 'Zvoľte spôsob platby',
    'Select region': 'Zvoľte kraj',
    'Select shipping method': 'Zvoľte spôsob doručenia',
    'Select store pickup': 'Vyberte vyzdvihnutie v obchode',
    'Select store pickup to precede': 'Ak chcete pokračovať, vyberte obchod na vyzdvihnutie',
    'Select the store': 'Zvoľte obchod',
    'Select this store': 'Vyberte tento obchod',
    'Select value': 'Zvoľte hodnotu',
    'Selected Store': 'Zvolený obchod',
    'Seleziona il metodo di spedizione': 'Zvoľte spôsob dodania',
    'Send remainder': 'Zaslanie e-mailu s heslom',
    'Service unavailable, retry later': 'Vyskytla sa chyba pri zadávaní, skúste to o chvíľu',
    'Session expired, page will reload': 'Relácia vypršala, stránka sa znova načíta',
    'shipping': 'Cena za dopravu',
    'Shipping': 'Doprava',
    'Shipping address': 'Doručovacia adresa',
    'Shipping and handling': 'Doprava a manipulácia',
    'Shipping data': 'Údaje o doručení',
    'Shipping informations': 'Informácie o doručení',
    'Shop opening hours': 'Otváracia doba obchodu',
    'Shopping Cart': 'Nákupný košík',
    'shopping details': 'detail nákupu',
    'Size': 'Veľkosť',
    'Something went wrong during Yandex Checkout': 'Počas Yandex odhlasovaní sa niečo pokazilo',
    'State/Region': 'Okres',
    'Store selection': 'Voľba obchodu',
    'street': 'ulica',
    'Street': 'Ulica',
    'Street number': 'Popisné číslo',
    'Sunday': 'Nedeľa',
    'Surname': 'Priezvisko',
    'Tax included': 'S daňou',
    'Telephone': 'Telefón',
    'Telephone number': 'číslo telefónu',
    'Telephone number for courier / store pickup': 'Telefónne číslo na vyzdvihnutie kuriérom/predajňou',
    'Terranova stores near you': 'Obchody Terranova vo vašej blízkosti',
    'The coupon code isn\'t valid. Verify the code and try again.': 'Neplatný kupón. Skontrolujte kód a skúste znova.',
    'The gift card is invalid or empty. Please check the gift card and try again': 'Darčeková karta je neplatná alebo prázdna. Skontrolujte darčekovú kartu a skúste to znova',
    'The maximum value of the usable We+Card bonus is': 'Maximálna použiteľná hodnota bonusu WE je',
    'The maximum value of the usable WE+Card points is': 'Maximálna hodnota použiteľných bodov WE karty je',
    'The order is already been paid, please wait while order is placing': 'Objednávka je už zaplatená, počkajte, kým sa objednávka zrealizuje',
    'The password must be made up of at least 8 characters, including a capital letter, a small letter, a number and a special character (.;,!$#).': 'Heslo musí byť zložené z aspoň 8 znakov, pričom musí obsahovať aspoň jedno veľké písmeno, jedno malé písmeno, jednu číslicu a jeden špeciálny znak (.;,!$#).',
    'The requested qty is not available': 'Požadované množstvo nie je k dispozícii',
    'There has been an error. Please try again': 'Vyskytla sa chyba.Vyskytla sa chyba. Skúste znova',
    'This email already esists. Do the login or proceed as guest': 'Táto e-mailová adresa už existuje. Prihláste sa alebo pokračujte bez prihlásenia',
    'This product is not available, please remove it from cart to proceed': 'Tento výrobok nie je k dispozícii, pre pokračovanie ho odstráňte z nákupného košíka',
    'Thursday': 'Štvrtok',
    'To': 'Pre',
    'Total': 'Spolu',
    'Tuesday': 'Utorok',
    'Type of card': 'Typ karty',
    'Update address': 'Aktualizujte adresu',
    'Use Glam Card Bonus': 'Uplatniť bonus WE Card',
    'Use points': 'Uplatniť bonus',
    'Use WE+ points': 'Použite body WE karty',
    'User': 'Používateľ',
    'Valid until': 'platnosť do',
    'VAT number': 'Daňové registračné číslo',
    'Verify billing address': 'Overte fakturačnú adresu',
    'Verify Gift Card': 'Overte darčekovú kartu',
    'Verify payment method selection': 'Overte výber spôsobu platby',
    'Verify shipping address': 'Overte dodaciu adresu',
    'Verify shipping method selection': 'Overte výber spôsobu dopravy',
    'View your cart': 'Zobraziť váš košík',
    'Wait for page to reload': 'Počkajte na opätovné načítanie stránky',
    'We\'re unable to send the password reset email': 'Nebolo možné odoslať e-mail na obnovenie hesla. Skontrolujte zadanú e-mailovú adresu',
    'Wednesday': 'Streda',
    'You are ordering with this email address': 'Objednávka je priradená k tejto e-mailovej adrese',
    'You are shipping in a foreign country': 'Doručenie do zahraničia',
    'Your available points': 'Použiť body we karty',
    'Your avalaible bonus': 'Bonusový kredit',
    'Zip code': 'PSČ',
    'Zip or city': 'PSČ alebo mesto',
    'zipdigitwarnings': 'Warning the zip code should consist of {zipdigits} charachters',
    'Shipping cost excluded': 'Nezahŕňa poštovné',
    'Extra address': 'Dodatočné informácie (nepovinné)',
    'Extra address placeholder': 'Príjemca, číslo bytu, časť obce, meno na zvončeku',
    '8 characters': '8 znakov',
    '1 lowercase letter': '1 malé písmeno',
    '1 uppercase letter': '1 veľké písmeno',
    '1 number': '1 číslo',
    '1 special character': '1 špeciálny znak',
    'Now you can use your points': 'Teraz môžete použiť svoje body',
    'Hallo': 'Dobrý deň',
    'Save Credit Card (One Click Payment)': 'Uložiť kreditnú kartu (platba jedným klikom)',
    'Pay with a saved credit card': 'Platba uloženou kreditnou kartou',
    'Pay with a new credit or debit card': 'Platba novou kreditnou alebo debetnou kartou',
    'Expiration': 'Koniec platnosti',
    'Other': 'Iné',
    'Applied discounts': 'Uplatnené zľavy',
    'Choose size': 'Zvoliť veľkosť',
    'Municipality': 'Obec',
    'amount-for-freeshipping': 'Do získania bezplatnej dopravy kuriérom vám chýba {amount}',
    'klarna-threshold-warning': 'Platba s Klarna je možná len pri minimálnej sume {amount} eur',
    'To proceed you must select a payment method': 'Ak chcete pokračovať, musíte vybrať spôsob platby',
    'To proceed you need to save the selected billing address': 'Ak chcete pokračovať, musíte uložiť zvolenú fakturačnú adresu',
    'To proceed it is necessary to accept the general conditions of sale': 'Ak chcete pokračovať, je potrebné akceptovať všeobecné podmienky predaja',
    'To proceed you need to select the store': 'Ak chcete pokračovať, musíte si vybrať obchod',
    'To proceed you need to save your changes': 'Ak chcete pokračovať, musíte uložiť zmeny',
    'Are you sure you want to delete this address?': 'Určite chcete túto adresu vymazať?',
    'To proceed you need to save the selected shipping address': 'Pre pokračovanie je potrebné uložiť zvolenú dodaciu adresu',
    'message-double_optin_using_point_disabled': 'Za tento nákup nemôžete uplatniť body keďže ste ešte nepotvrdili platnosť váš e-mail alebo telefónne číslo. Kontaktujte náš zákaznícky servis v prípade pochýb.',
}

export default sk;
export const skValidation = {
    name: "sk",
    messages: {
        _default: function (e: any) {
            return "údaj v políčku " + e + " neplatný."
        },
        after: function (e: any, n: any) {
            return "... " + e + " musí byť pred " + n[0] + "."
        },
        alpha: function (e: any) {
            return "políčko" + e + " môže obsahovať iba znaky abecedy."
        },
        alpha_dash: function (e: any) {
            return "políčko" + e + " môže obsahovať abecedno-číselné znaky, pomlčky a podčiarkovníky."
        },
        alpha_num: function (e: any) {
            return "políčko " + e + " môže obsakovať iba abecedno-číselné znaky."
        },
        alpha_spaces: function (e: any) {
            return "políčko " + e + " môže obsahovať iba abecedno-číselné znaky a medzery."
        },
        before: function (e: any, n: any) {
            return "políčko " + e + " musí byť pred " + n[0] + "."
        },
        between: function (e: any, n: any) {
            return "políčko " + e + " sa musí nachádzať medzi " + n[0] + " a " + n[1] + "."
        },
        confirmed: function (e: any, n: any) {
            return "políčko " + e + " sa nezhoduje s " + n[0] + "."
        },
        credit_card: function (e: any) {
            return "políčkoa " + e + " je neplatné."
        },
        date_between: function (e: any, n: any) {
            return "... " + e + " sa musí nachádzať medzi " + n[0] + " a " + n[1] + "."
        },
        date_format: function (e: any, n: any) {
            return "... " + e + " musí mať formát " + n[0] + "."
        },
        decimal: function (e: any, n: any) {
            void 0 === n && (n = []);
            var r = n[0];
            return void 0 === r && (r = "*"), "políčko " + e + " musí byť číselné a môže obsahovať" + (r && "*" !== r ? " " + r : "") + "desatinné miesta."
        },
        digits: function (e: any, n: any) {
            return "políčko " + e + " musí byť číselné a musí obsahovať presne " + n[0] + " čísel."
        },
        dimensions: function (e: any, n: any) {
            return "políčko " + e + " musí byť " + n[0] + " x " + n[1] + "."
        },
        email: function (e: any) {
            return "políčko " + e + " musí obsahovať platnú e-mailovú adresu."
        },
        excluded: function (e: any) {
            return "políčko " + e + " musí obsahovať platnú hodnotu."
        },
        ext: function (e: any) {
            return "políčko " + e + " musí obsahovať platný súbor."
        },
        image: function (e: any) {
            return "políčko " + e + " musí obsahovať obrázok."
        },
        included: function (e: any) {
            return "políčko " + e + " musí obsahovať platnú hodnotu."
        },
        ip: function (e: any) {
            return "políčko " + e + " musí obsahovať platnú IP adresu."
        },
        length: function (e: any, n: any) {
            return "Dĺžka políčka " + e + " musí byť" + n[0] + "."
        },
        max: function (e: any, n: any) {
            return "políčko " + e + " nesmie byť dlhšie ako " + n[0] + " znakov."
        },
        max_value: function (e: any, n: any) {
            return "políčko " + e + " musí byť kratšie alebo sa rovnať " + n[0]
        },
        mimes: function (e: any) {
            return "políčko " + e + " musí obsahovať platný typ súboru."
        },
        min: function (e: any, n: any) {
            return "políčko " + e + " musí mať najmenej " + n[0] + " znakov."
        },
        min_value: function (e: any, n: any) {
            return "políčko " + e + " musí byť dlhšie alebo sa rovnať " + n[0]
        },
        numeric: function (e: any) {
            return "políčko " + e + " môže obsahovať iba číselné znaky."
        },
        regex: function (e: any) {
            return "políčko " + e + " nemá platný formát."
        },
        required: function (e: any) {
            return "políčko " + e + " je povinné."
        },
        size: function (e: any, n: any) {
            return "políčko " + e + " musí byť kratšie ako " + function (e) {
                const n = 1024;
                const r = 0 === (e = Number(e) * n) ? 0 : Math.floor(Math.log(e) / Math.log(n));
                const f = parseFloat((e / Math.pow(n, r)).toFixed(2));
                const v = 1 * f;
                return v.toFixed(2) + " " + ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][r]
            }(n[0]) + "."
        },
        url: function (e: any) {
            return "políčko " + e + " obsahuje neplatnú URL."
        },
        'validate-piva-cf': function (e: any) {
            return 'neplatné IČ DPH/DRČ.';
        },
        'validate-regionid': function (e: any) {
            return 'políčko Kraj je povinné.';
        },
        'validate-ascii': function(e: any) {
            return 'Zadajte svoje meno a priezvisko bez špeciálnych znakov';
        },
        'validate-streetandnumber': function(e: any, n: any) {
            return 'Street and street number fields must not exceed {2} charachters';
        },
        'validate-data-consensus': function(e: any) {
          return 'Na spracovanie osobných údajov je potrebný váš súhlas.';
        },
        'validate-gender': function(e: any) {
            return 'Pole Pohlavie je povinné.';
        },
        'validate-password': function(e: any) {
            return 'Heslo musí byť zložené z aspoň 8 znakov, pričom musí obsahovať aspoň jedno veľké písmeno, jedno malé písmeno, jednu číslicu a jeden špeciálny znak (.;,!$#).';
        },
    },
    attributes: {}
};
